import type { DocumentInitParameters, PDFDocumentProxy } from 'pdfjs-dist/types/src/display/api';

export type {
  TextItem,
  TextContent,
  PDFDocumentProxy,
  PDFPageProxy,
} from 'pdfjs-dist/types/src/display/api';

/**
 * pdfjs-dist is 164 KB gzipped and reached from the migrations service, so it
 * used to sit in the shell chunk. It now loads on the first getDocument() call
 * (Phase E split); the call shape `getDocument(src).promise` is unchanged.
 */
type Pdfjs = typeof import('pdfjs-dist/legacy/build/pdf');
let lib: Promise<Pdfjs> | undefined;
const loadPdfjs = () => {
  if (!lib) {
    lib = import('pdfjs-dist/legacy/build/pdf').then((m) => {
      m.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';
      return m;
    });
  }
  return lib;
};

type GetDocumentSource = Parameters<Pdfjs['getDocument']>[0];

const pdfjs = {
  getDocument(src: GetDocumentSource): { promise: Promise<PDFDocumentProxy> } {
    return { promise: loadPdfjs().then((m) => m.getDocument(src as DocumentInitParameters).promise) };
  },
};

export default pdfjs;
